exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* START EVOQ COLOR PALETTE */\n/* END EVOQ COLOR PALETTE */\n/* START ATTENTION COLORS */\n/* END ATTENTION COLORS */\n/* SVG HOVER STATES */\nsvg {\n  fill: #C8C8C8;\n}\nsvg:hover {\n  fill: #6F7273;\n}\nsvg:active {\n  fill: #1E88C3;\n}\n/* END SVG HOVER STATES */\n._2Xt8DULLqGSSdJBTY-9ljb {\n  width: 100%;\n  overflow: hidden;\n}\n._2Xt8DULLqGSSdJBTY-9ljb .container {\n  background-color: #EFF0F0;\n  border: solid 1px #E5E7E6;\n}\n", ""]);

// Exports
exports.locals = {
	"moduleContainer": "_2Xt8DULLqGSSdJBTY-9ljb"
};